import {ErrorMessage} from 'formik';
import {useTranslation} from 'react-i18next';

import {Box, Typography} from '@mui/material';

import {RichTextEditor} from '../../../../../../../../../components/RichTextEditor/RichTextEditor';

interface Props {
  formik: any;
}

export const AboutTheJobFieldsRequirements = ({formik}: Props) => {
  const {t} = useTranslation();
  const onChange = (text: string) => {
    formik.setFieldValue('requirements', text);
  };

  return (
    <>
      <Box sx={{mb: 5}}>
        <Typography variant='h4' gutterBottom component='div'>
          {t('companyJobPostings.newJobDialog.formLabels.requirements')}*
        </Typography>
        <RichTextEditor
          isEditable={true}
          readText={onChange}
          defaultText={formik.initialValues.requirements}
          fontSize='20px'
        />
        <Typography variant='body2' color='error'>
          <ErrorMessage name='requirements' component='span' />
        </Typography>
      </Box>
    </>
  );
};
